module.exports = __webpack_public_path__ + "img/grz-3.fb78c8b2.png";